<template>
    <v-text-field :label="label" :value="item" :readonly="true" :dense="true" :disabled="disabled" />
</template>

<script>
    import axios from 'axios'

    export default {
        props: [
            'label',
            'value',
            'apiMethod',
            'disabled'
        ],

        data() {
            return {
                item: ''
            };
        },

        methods: {
        },

        watch: {
            value: {
                immediate: true,
                async handler(value) {
                    if (typeof value !== 'undefined' && value !== null) {
                        var params = {};
                        params['filter.id'] = value;
                        var response = await axios.get('/api/' + this.apiMethod + '/Autocomplete', { params })
                        this.item = response.data.results[0].label;
                    }
                }
            }
        }
    };
</script>
